module.exports = __webpack_public_path__ + "static/media/Newsletter.25b15fb6.png";